import React from "react";
import CategoriesDropdown from "./CategoriesDropdown";
import { createCompanyStoreOptions } from "../../utilities/storeUtility";
import { globalConstants } from "../../../constants";

const CompanyStoreDropdown = ({
  currentStoreCompany,
  companyStores,
  selectedStore,
  setSelectedStore,
  className = "dashboard-dropdown-type",
}) => {
  if (currentStoreCompany?.isDummyCompany || !currentStoreCompany) {
    return null;
  }

  return (
    <CategoriesDropdown
      label="Store"
      options={createCompanyStoreOptions(companyStores || [])}
      handleChange={(e) => {
        setSelectedStore(
          e == null
            ? {
                label: globalConstants.ALL_STORES,
                value: globalConstants.ALL_STORES,
              }
            : e
        );
      }}
      noOptionsMessage="No Store Found"
      placeholder="Select Store"
      className={className}
      isClearable={false}
      value={selectedStore}
    />
  );
};

export default CompanyStoreDropdown;
